export default __webpack_public_path__ + "static/media/mp.2ddc6a66.svg";